export default __webpack_public_path__ + "static/media/71t.6cdb83c8.jpg";